import type { PrimitivePermissionType } from '@repo/api-codegen';
import type { INotificationSettings } from '../../api/types/models/notification';
import type { FeatureFlags } from '../../utils/featureFlags/types';

export const notifications: Array<{
	attribute: keyof INotificationSettings;
	description: string;
	category: string;
	allowedTypes?: Array<'app' | 'email' | 'slack'>;
	featureFlag?: keyof FeatureFlags;
	title?: string;
	adminOnly?: boolean;
}> = [
	// Digest
	{
		attribute: 'secoda_weekly',
		description: 'Weekly summary of important activities and updates',
		category: 'Digest',
		allowedTypes: ['email'],
	},
	{
		attribute: 'secoda_monthly',
		description: 'Monthly digest of system activities and trends',
		category: 'Digest',
		allowedTypes: ['email'],
	},
	// General
	{
		attribute: 'notify_announcement',
		description: 'Announcements from members in your workspace',
		category: 'General',
		title: 'Announcements',
	},
	{
		attribute: 'notify_comments',
		description: 'Comments, replies, and thread resolutions',
		category: 'General',
		title: 'Comments and replies',
	},
	{
		attribute: 'notify_resource_updates',
		description:
			'Content and property edits to resources you are subscribed to',
		category: 'General',
		title: 'Resource updates',
	},
	{
		attribute: 'notify_mentions',
		description: 'Mentions in comments or content',
		category: 'General',
		title: 'Mentions',
	},
	{
		attribute: 'notify_security',
		description: 'Members join workspace or create API key',
		category: 'General',
		title: 'Security',
		adminOnly: true,
	},
	// Features
	{
		attribute: 'notify_integrations',
		description: 'Sync failures',
		category: 'Features',
		title: 'Integrations',
		adminOnly: true,
	},
	{
		attribute: 'notify_monitors',
		description: 'Incidents are created, acknowledged, or resolved',
		category: 'Features',
		title: 'Monitors',
	},
	{
		attribute: 'notify_questions',
		description:
			'New questions, replies, edits, ownership changes, or accepted answers',
		category: 'Features',
		title: 'Questions',
	},
	// todo: add back in when policies is working again
	// {
	// 	attribute: 'notify_policies_status',
	// 	description: 'Issues are created or resolved',
	// 	category: 'Features',
	// 	title: 'Policies',
	// },
	{
		attribute: 'notify_requests',
		description: 'Created, approved, rejected, or expiring access requests',
		category: 'Features',
		title: 'Access requests',
	},
	{
		attribute: 'notify_automation_review',
		description: 'Reviews and failures',
		category: 'Features',
		title: 'Automations',
	},
	{
		attribute: 'notify_ai_agents',
		description: 'Agent updates',
		category: 'Features',
		title: 'Secoda AI',
	},
];

export const MINIMUM_REQUIRED_PERMISSIONS: PrimitivePermissionType[] = [
	'Integrations.Read',
	'Teams.Read',
	'Teams.Join',
	'Users.Read',
	'Resources.Read',
	'Properties.Read',
];
